import { withState } from 'recompose';

export default withState('isAdding', 'setIsAdding', false);
